import React from 'react';
import './Navbar.css';

const Navbar: React.FC = () => {
  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-phone">
            <i className="phone-icon" style={{color: 'white'}}>📞</i>
            <a href="https://wa.me/5534997800202" target="_blank" rel="noopener noreferrer" style={{color: 'white'}}>
              <span>(34) 99780-0202 - CTBC</span>
            </a>
          </div>
          <div className="navbar-info">
            <span>Garcias Milho - Qualidade e Tradição</span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
